import {Component, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {IDocumentTypesDto} from '../../documents/dto/document-listing.dto';
import {DocumentTypeService} from '../../settings/documenttype/document-type.service';

export enum ActivateNewDocumentTypeForEnum {
    DOCUMENT_ONLY = 1,
    CONTRACT_ONLY = 2,
    DOCUMENT_AND_CONTRACT = 3
}

@Component({
  selector: 'app-document-type-form-modal',
  templateUrl: './document-type-form-modal.component.html',
  styleUrl: './document-type-form-modal.component.scss'
})
export class DocumentTypeFormModalComponent implements OnInit {

  public documentTypeForm: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;
  public documentType: IDocumentTypesDto;

 /**
  * Constructor
  * @param modalService 
  * @param formBuilder 
  * @param documentTypeService 
  * @param globalService 
  * @param _sharedStoreFacade$ 
  * @param _translocoService 
  */
  constructor(
    private modalService: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private documentTypeService: DocumentTypeService,
    private globalService: GlobalService,
    private _sharedStoreFacade$: SharedStoreFacade,
    private _translocoService: TranslocoService
  ) { }

  ngOnInit(){
    this.initForm(this.documentType ?? {});
  }

  /**
   * Init form with data;
   * @param data 
   */
  initForm(data: IDocumentTypesDto) {
    this.documentTypeForm = this.formBuilder.group({
      id: [data.id ?? ''],
      document_type: [data.document_type ?? '', [Validators.required]],
      description: ['']
    });
  }


  /** 
    * Convenience getter for easy access to form fields 
    */
  get form() {
    return this.documentTypeForm.controls;
  }


  /**
   * Close modal and reseting form values
   */
  closeModel() {
    this.modalService.close({success:0,data:{}});
    this.documentTypeForm.reset();
  }



  submitDocumentType() {
    this.submitted = true;
    if (this.documentTypeForm.invalid) return;

    this.loading = true;
    this.documentTypeService.submitDocumentTypes( {
        ...this.documentTypeForm.value,
        selector_for: ActivateNewDocumentTypeForEnum.DOCUMENT_AND_CONTRACT.toString()
    }) 
     .subscribe({
      next: (response) => {
        this.globalService.toastrSuccess(this._translocoService.translate('Document has been created toaster message - (Document type section) - Document type has been created'));
        this.loading = false;
        this.submitted = false;
        this.modalService.close({success: 1, data: response});
        this.documentTypeForm.reset();
        this._sharedStoreFacade$.getDocumentTypes();
      },

      error: (error) => {
        this.loading = false;
        this.submitted = false;
        this.globalService.toastrError(error);
      }
    });
  }
}
